import request from 'sb-request/graphql'

import pixelApplyQuery from './pixelApply.graphql'

import type { PixelApplyPayload, PixelApplyVariables } from './pixelApplyGQL'


export type ApplyPixelResult = PixelApplyPayload['pixelApply']

// ATTN this method for marketing pixels analytics. Used in GTM and save data in mixpanel.
// You can check event "Pixel fire".
const applyPixel = (input: PixelApplyVariables['input']): Promise<ApplyPixelResult> =>
  request<PixelApplyVariables, PixelApplyPayload, ApplyPixelResult>('pixelApply', {
    query: pixelApplyQuery,
    variables: { input },
  }, {
    withErrorModal: false,
  })


export default {
  applyPixel,
}
